// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"37b92d90","455":"9dfacc57","977":"0442f502"}[chunkId] + ".chunk.js";
};